export function getCard(state) {
  return state.card;
}

export function getDraftCard(state) {
  return state.draftCard;
}

export function getListDocuments(state) {
  return state.listDocuments;
}

export function getListLegalSources(state) {
  return state.listLegalSources;
}
